export function smartSizeSelection (needle, haystack) {
  // Needle equals item in haystack
  for (let i = 0; i < haystack.length; i++) {
    let item = haystack[i]
    if (needle.toLowerCase() === item.toLowerCase()) {
      return item
    }
  };

  // Item in haystack starts with needle
  for (let i = 0; i < haystack.length; i++) {
    let item = haystack[i]
    if (item.toLowerCase().indexOf(needle.toLowerCase()) === 0) {
      return item
    }
  };

  return false
}

export function smartSizeSelectionVP (needle, haystack) {
  // Needle equals item in haystack
  // VP workaround, only select size if fully matched
  for (let i = 0; i < haystack.length; i++) {
    let item = haystack[i]
    if (needle.toLowerCase() === item.toLowerCase()) {
      return item
    }
  };
  return false
}



// WEBPACK FOOTER //
// ./src/js/components/select-size.js